// component mixin
import { get, camelize } from '../utils';

export default {
  computed: {
    $t() {
      const { name } = this.$options;
      const prefix = name ? camelize(name) + '.' : '';
      console.info('prefix: ' + prefix + ' $vantLang: ' + this.$vantLang)
      const messages = this.$vantMessages[this.$vantLang];

      return (path, ...args) => {
        const message = get(messages, prefix + path) || get(messages, path);
        return typeof message === 'function' ? message.apply(null, args) : message;
      };
    }
  }
};



// WEBPACK FOOTER //
// ./src/plugins/jscom/omui/components/mixins/i18n.js